/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Loading_OlderInputs */

const cs_chat_loading_older = /** @type {(inputs: Chat_Loading_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání starších zpráv…`)
};

const en_chat_loading_older = /** @type {(inputs: Chat_Loading_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading older messages…`)
};

/**
* | output |
* | --- |
* | "Loading older messages…" |
*
* @param {Chat_Loading_OlderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_loading_older = /** @type {((inputs?: Chat_Loading_OlderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Loading_OlderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_loading_older(inputs)
	return cs_chat_loading_older(inputs)
});